export default __webpack_public_path__ + "assets/images/cf8512b2640fe7001cd732ab0c014ad4.jpg";